export default __webpack_public_path__ + "static/media/zawodnik12.ff20080f.png";